import {PaymentActionType} from "../Constants/PaymentActionType";

export const setPaymentPreparedData = data => {
	return {
		type: PaymentActionType.SET_PAYMENT_PREPARED_DATA,
		payload: data,
	};
};
